// extracted by mini-css-extract-plugin
export default {"popupContainer":"MezaPopup_popupContainer__hqBq6","readMore":"MezaPopup_readMore__R1YaF"};